/* eslint-disable multiline-ternary */
import React from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import { Box, Typography } from '@mui/material'
import config from '../../config/config'
import {
  StyledTableHeadingCell,
  StyledTableCell,
  StyledTableRow
} from './ScoringSummary'

function createData(score, mainStreets, urban, smallTown, subUrban, rural) {
  return { score, mainStreets, urban, smallTown, subUrban, rural }
}

const rows = [
  createData('Score 1 (Highest)', true, true, true, true, true),
  createData('Score 2', true, true, true, true, true),
  createData('Score 3', false, false, false, false, true),
  createData('Score 4 (Lowest)', false, false, false, false, false)
]

export default function ScoringCriteriaTable() {
  const scoringSummaryFields = [
    'Score',
    'Main Street',
    'Urban or Walkable Thoroughfares',
    'Small Town Hamlet or Village Commercial',
    'Suburban Corridors',
    'Rural'
  ]
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {scoringSummaryFields.map((field) => (
                <StyledTableHeadingCell key={`${field}-header`}>
                  {field}
                </StyledTableHeadingCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <StyledTableRow key={row.score}>
                <StyledTableCell component="th" scope="row">
                  {row.score}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  sx={{
                    backgroundColor: row.mainStreets
                      ? config.themeConfig.contrastColor
                      : 'white'
                  }}
                >
                  {row.mainStreets ? (
                    <CheckIcon style={{ color: '#FFFFFF' }} />
                  ) : (
                    <CloseIcon />
                  )}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  sx={{
                    backgroundColor: row.urban
                      ? config.themeConfig.contrastColor
                      : 'white'
                  }}
                >
                  {row.urban ? (
                    <CheckIcon style={{ color: '#FFFFFF' }} />
                  ) : (
                    <CloseIcon />
                  )}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  sx={{
                    backgroundColor: row.smallTown
                      ? config.themeConfig.contrastColor
                      : 'white'
                  }}
                >
                  {row.smallTown ? (
                    <CheckIcon style={{ color: '#FFFFFF' }} />
                  ) : (
                    <CloseIcon />
                  )}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  sx={{
                    backgroundColor: row.subUrban
                      ? config.themeConfig.contrastColor
                      : 'white'
                  }}
                >
                  {row.subUrban ? (
                    <CheckIcon style={{ color: '#FFFFFF' }} />
                  ) : (
                    <CloseIcon />
                  )}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  sx={{
                    backgroundColor: row.rural
                      ? config.themeConfig.contrastColor
                      : 'white'
                  }}
                >
                  {row.rural ? (
                    <CheckIcon style={{ color: '#FFFFFF' }} />
                  ) : (
                    <CloseIcon />
                  )}
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ p: 2 }}>
        {' '}
        <Box sx={{ display: 'flex', gap: '5px' }}>
          <Box sx={{ backgroundColor: config.themeConfig.contrastColor, p: 1 }}>
            <CheckIcon sx={{ color: 'white' }} />
          </Box>
          <Typography
            variant="body1"
            sx={{
              color: config.themeConfig.lightTextColor,
              fontStyle: 'italic',
              alignSelf: 'center'
            }}
          >
            Meets or exceeds objective
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: '2px' }}>
          <Box sx={{ p: 1 }}>
            <CloseIcon />
          </Box>
          <Typography
            variant="body1"
            sx={{
              color: config.themeConfig.lightTextColor,
              fontStyle: 'italic',
              alignSelf: 'center'
            }}
          >
            Needs improvement
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
